import React from 'react';
import Modal from 'react-modal';

import { getAsset } from '../../../../../util/assets';
import {
  isNativeAppWebView,
  postNativeAppCustomConfiguratorDismiss,
} from '../../../../../services/native-bridge/native-apps-interface';
import Button from '../../../Button';

const CustomPrintConfigurationSuccess = () => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen
      bodyOpenClassName="custom-print-config-body-modal-open"
      overlayClassName="custom-print-config-success-modal-overlay"
      className="custom-print-config-success-modal-content"
    >
      <div className="custom-print-config-success">
        <img
          src={getAsset('/waldo-excited.png')}
          alt=""
          width="84"
          className="mt-5 mb-4"
        />

        <p className="text-lg text-extra-bold mb-1">You are all set!</p>

        <p className="m-0 text-md">
          Your order is being processed and you&rsquo;ll receive it soon!
        </p>

        {isNativeAppWebView() && (
          <Button
            className="btn-custom-print-succcess-dismiss"
            btnSize="lg"
            btnStyle="link"
            onClick={postNativeAppCustomConfiguratorDismiss}
          >
            Go back
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default CustomPrintConfigurationSuccess;
